import { ComponentProps, ReactNode } from 'react';
import { Stack } from '../../../design-system/stack/stack';
import { cn } from '../../../utils/cn';
import { SendPaymentToXeroCard } from '../../integrations/components/send-payment-to-xero-card';

type PaymentsFlowContentWrapperProps = {
  children: ReactNode;
  isFullScreenWidth?: boolean;
  xeroCardConfig?:
    | {
        isCardVisible: false;
      }
    | {
        isCardVisible: true;
        onConnect: () => void;
        onClose: () => void;
      };
};

export const PaymentsFlowContentWrapper = ({
  children,
  isFullScreenWidth = false,
  xeroCardConfig = { isCardVisible: false },
}: PaymentsFlowContentWrapperProps) => {
  if (!xeroCardConfig.isCardVisible) {
    return (
      <PaymentsFlowContentInnerWrapper isFullScreenWidth={isFullScreenWidth}>
        {children}
      </PaymentsFlowContentInnerWrapper>
    );
  }

  return (
    <Stack>
      <PaymentsFlowContentInnerWrapper isFullScreenWidth={isFullScreenWidth}>
        {children}
      </PaymentsFlowContentInnerWrapper>

      <div className="mx-auto max-w-[840px]">
        <SendPaymentToXeroCard onConnect={xeroCardConfig.onConnect} onClose={xeroCardConfig.onClose} />
      </div>
    </Stack>
  );
};

const PaymentsFlowContentInnerWrapper = (
  props: Omit<ComponentProps<typeof PaymentsFlowContentWrapper>, 'xeroCardConfig' | 'isFullScreenWidth'> & {
    isFullScreenWidth: NonNullable<ComponentProps<typeof PaymentsFlowContentWrapper>['isFullScreenWidth']>;
  },
) => {
  return (
    <div
      className={cn('mx-auto my-10 w-[520px]', {
        'w-screen px-32': props.isFullScreenWidth,
      })}
    >
      {props.children}
    </div>
  );
};
